import * as qm from 'src/utils/utils'
import moment from 'moment'
export default {
  computed: {
    publicationStatus() {
      const status = this.initPublicationStatus()
      const pubType = this.$route.path.split('/')[1]
      if (pubType === 'podcast') {
        if (status.text === '未发布') {
          status.text = '未授权'
          status.buttonText = '预览小程序'
        }
      }
      return status
    },
  },
  methods: {
    initPublicationStatus() {
      if (!this.publicationInfo) {
        return
      }
      const type = this.publicationInfo.pubType
      const scope = this.publicationInfo.scope || {}
      const $expired = scope.isExpired
      if (type === 'quiz') {
        // 公版
        // if (this.publicationInfo.status === 'published') {
        //   return {
        //     color: 'online',
        //     text: '已发布至「轻芒答题」',
        //     status: 'publicPublished',
        //   }
        // }
        // 已过期
        if ($expired) {
          return {
            color: 'failed',
            text: '小程序已暂停访问',
            status: 'expired',
          }
        }
        return {
          color: 'offline',
          text: '未发布',
        }
      } else {
        // type === 'content' / 'podcast' / 'brand'
        const $release = qm.has(
          this.publicationInfo,
          'appInfo.versions.release',
        )
        // 已授权
        const $hasAuthored =
          this.publicationInfo.appId && this.publicationInfo.appInfo
        // 授权失败
        const $authorizationFailed =
          this.publicationInfo.appId && !this.publicationInfo.appInfo
        const status = qm.get(
          this.publicationInfo,
          'appInfo.versions.review.status',
        )
        const $rejected = status === 'rejected'
        const $reviewing = status === 'reviewing'
        const $publicPublished = this.publicationInfo.status === 'published'
        // 已过期
        if ($expired) {
          return {
            color: 'failed',
            text: '小程序已暂停访问',
            status: 'expired',
          }
        }
        // 已发布独立小程序
        if ($release && $reviewing) {
          return {
            color: 'online', // 'unReady', 'reviewing', 'online', 'offline'
            text: '已发布独立小程序',
            info: 'needUpdate',
            status: 'needUpdate',
          }
        }
        if ($release) {
          return {
            color: 'online',
            text: '已发布独立小程序',
            // buttonText: '推广',
            status: 'privatePublished',
          }
        }
        if ($rejected) {
          return {
            color: 'failed',
            text: '审核失败',
            info: 'failed',
            buttonText: '重新提审',
            reason:
              qm.get(this.publicationInfo, 'appInfo.versions.review.info') ||
              '原因未知',
            status: 'rejected',
          }
        }
        if ($reviewing) {
          let createdTime = ''
          let templateId = ''
          let operator = 'internal'
          if (
            qm.has(this.publicationInfo, 'appInfo.versions.preview.createdTime')
          ) {
            createdTime = moment(
              this.publicationInfo.appInfo.versions.preview.createdTime,
            ).format('YYYY年M月D日')
            templateId = this.publicationInfo.appInfo.versions.preview
              .templateId
            operator = this.publicationInfo.appInfo.versions.review.operator
          }
          return {
            color: 'reviewing',
            text: '审核中',
            info: 'reviewing',
            buttonText: '查看审核状态',
            status: 'reviewing',
            templateId: templateId,
            createdTime: createdTime,
            operator: operator,
          }
        }
        // 已授权
        if ($hasAuthored) {
          return {
            color: 'reviewing',
            text: '已授权',
            buttonText: '提交审核',
            info: 'publicPublished',
            status: 'hasAuthored',
          }
        }
        if ($authorizationFailed) {
          return {
            color: 'failed',
            text: '授权失败',
            info: 'authorizationFailed',
            buttonText: '重新授权',
            status: 'authorizationFailed',
          }
        }
        if ($publicPublished) {
          return {
            // color: 'online',
            color: 'offline',
            // text: '已发布至「轻芒杂志」',
            text: '未发布',
            buttonText: '发布小程序',
            info: 'publicPublished',
            status: 'publicPublished',
          }
        }
        return {
          color: 'offline',
          text: '未发布',
          buttonText: '发布小程序',
          status: 'offline',
        }
      }
    },
  },
}
